//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    link: {
      type: String,
      default: '#',
      require: true
    },
    imageUrl: {
      type: String,
      require: false
    },
    imageAlt: {
      type: String,
      require: true,
      default: 'alt image'
    },
    title: {
      type: String,
      require: false
    },
    location: {
      type: String,
      require: false
    },
    homeStyle: {
      type: String,
      require: false
    },
    categories: {
      type: Array,
      require: false,
      default: []
    }
  }
};